<template>
  <div class="RowLine"
       :class="[{
        LastEndItem: !isRecover && isLastRow && proMode,
        LastEndTwo: !isRecover && isLastTowRow && proMode,
        isPro: isPro,
        freeMode: !proMode
       }]">
    <Reward
      v-for="item in rowData"
      :key="item.id"
      :level="item.level"
      :image_url="item.icon_url"
      :count="item.reward_num"
      :state="item.state"
      :id="item.id"
      :reward_item="item"
      :period_id="period_id"
      :isClaiming="claimingState"
      :isPro="isPro"
      :isLockUpgraded="isLockUpgraded"
      @rewardClick="rewardClick"
      @claiming="handleClaiming"
    ></Reward>
    <div class="tag"
        v-if="proMode"
        :class="{ProTag: isPro}">
      {{ isPro ? localesPackage?.['katharsis_pro']?.[localesEnv] : localesPackage?.['katharsis_free']?.[localesEnv] }}    
      <img :src="require('@/assets/images/YuliApp/weeklyTask/white_lock.svg')" v-if="isPro && !isLockUpgraded">
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref } from "vue";
import Reward from "../Reward/index.vue";
import { REWARD_TYPE } from "@/constants/enums";
import { mapState } from "vuex";

export default {
  components: {
    Reward,
  },
  props: {
    rowData: {
      type: Object,
      default: null,
    },
    curLevel: {
      type: Number,
      default: 1,
    },
    period_id: {
      type: String,
      default: "",
    },
    isClaiming: {
      type: Boolean,
      default: false,
    },
    isLastRow: {
      type: Boolean,
      default: false,
    },
    isLastTowRow: {
      type: Boolean,
      default: false,
    },
    isEnding: {
      type: Boolean,
      default: false,
    },
    isPro: {
      type: Boolean,
      default: false,
    },
    isLockUpgraded: {
      type: Boolean,
      default: false,
    },
    proMode: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    rowData: {
      handler(value) {
        // console.log("rowData++++++++++", value);
      },
      immediate: true,
      deep: true,
    },
    isClaiming: {
      handler(value) {
        this.claimingState = value;
      },
      immediate: true,
      deep: true,
    },
    isEnding: {
      handler(value) {
        this.isRecover = value;
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { cur_claimed_level, curLevel } = props;
    const reward_state = ref(REWARD_TYPE.NOT_UNLOCKED); //未解锁
    const REWARD_TYPE_ENUM = ref(REWARD_TYPE);
    const claimingState = ref(false);
    const isRecover = ref(false);
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');

    onMounted(() => {});

    /**
     * 接收来自reward组件点击的参数
     */
    const rewardClick = (level, state, reward_item) => {
      emit("rewardClick", level, state, reward_item);
    };

    /**
     * 处理点击claim限制
     */
    const handleClaiming = (state,reward_item) => {
      emit("claiming", state,reward_item);
    };

    return {
      rewardClick,
      REWARD_TYPE_ENUM,
      claimingState,
      handleClaiming,
      isRecover,
      localesEnv,
      localesPackage,
    };
  },
};
</script>

<style lang="less" scoped>
.RowLine {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  width: 352px;
  height: 69px;
  // background: url("~@/assets/images/YuliApp/weeklyTask/bg_reward_row.svg")
  //   no-repeat top left;
  // background-size: 100% 100%;
  background-color: transparent;
  // margin-bottom: 12px;
  padding-left: 34px;
  position: relative;
}
.RowLine:first-child{
  margin-top: 56px;
}
.RowLine:last-child{
  margin-bottom: 60px;
}
.tag{
  position: absolute;
  top: 26px;
  left: 3px;
  width: 25px;
  height: 12px;
  color: #FFFFFF;
  font-size: 12px;
  font-family: "Josefin Sans SemiBold";
  text-align: center;
  letter-spacing: -0.24px;
  img{
    width: 16.63px;
    height: 16.63px;
  }
}
.FreeTag{
  background-color: #7585a7; 
}
.ProTag{
  // background: linear-gradient(#f59a23,#fce409);
  // z-index: 13;
}
.isPro{
  width: 352px;
  height: 69px;
  margin-bottom: 40px;
  // background: #fff8bd;
  background: url("~@/assets/images/YuliApp/weeklyTask/rewardline-bg.png")
    no-repeat top left;
  background-size: 100% 100%;
}
.freeMode{
  margin-bottom: 28px;
  padding-left: unset;
  background: url("~@/assets/images/YuliApp/weeklyTask/rewardline-bg.png")
    no-repeat top left;
  background-size: 100% 100%;
}
.LastEndItem {
  position: fixed;
  bottom: 0;
  z-index: 20;
  margin-bottom: unset !important;
}
.LastEndTwo {
  margin-bottom: 124px;
}
</style>
